
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import CourseCard from './CourseCard.vue'
import type { CalligraphyLevel2JsonResp, CourseItem } from '@xt/client/utils/activities/types'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg,
    CourseCard
  }
})
export default class Courses extends Vue {
  @Prop({ default: () => [] }) readonly courses!: Array<CourseItem>
  @Prop({ required: true }) readonly labels!: CalligraphyLevel2JsonResp['labels']

  getLabels(key: 'composition' | 'live' | 'practice' | 'adult') {
    return this.labels[key] ?? ''
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
